export default __webpack_public_path__ + "static/media/IDM pop up runoff coefficient.bed283ce.png";